<script setup lang="ts">
import { cardKey } from "@/components/StickyNote/injectKeys";
import SetStoryPoints from "@/components/menu/SetStoryPoints/SetStoryPoints.vue";
import { injectStrict } from "@/utils/vue";

import AttributeChip from "./AttributeChip.vue";

const card = injectStrict(cardKey);
</script>

<template>
  <AttributeChip
    name="story-points-chip"
    :text="card.points.toString()"
    :dropdown-props="{ width: 'auto' }"
    :tooltip="$t('statusDistribution.storyPoints')"
  >
    <SetStoryPoints />
  </AttributeChip>
</template>
